import React from 'react';
import { BrowserRouter as Router, Redirect, Route, useLocation } from 'react-router-dom';
import Navbar from './components/Navbar';
import LeaderBoard from './view/LeaderBoard';
import { PvEDoudizhuDemoView } from './view/PvEView';
import { DoudizhuReplayView, LeducHoldemReplayView } from './view/ReplayView';

const navbarSubtitleMap = {
    '/leaderboard': '',
    '/replay/doudizhu': 'Doudizhu',
    '/replay/leduc-holdem': "Leduc Hold'em",
    '/pve/doudizhu-demo': 'Doudizhu PvE Demo',
};

function AppRoutes() {
    const location = useLocation();
    const hideNavbar = location.pathname.startsWith('/pve/');

    return (
        <>
            {!hideNavbar && <Navbar subtitleMap={navbarSubtitleMap} />}
            <div style={{ marginTop: hideNavbar ? 0 : '75px' }}>
                <Route exact path="/">
                    <Redirect to="/leaderboard?type=game&name=leduc-holdem" />
                </Route>
                <Route path="/leaderboard" component={LeaderBoard} />
                <Route path="/replay/doudizhu" component={DoudizhuReplayView} />
                <Route path="/replay/leduc-holdem" component={LeducHoldemReplayView} />
                <Route path="/pve/doudizhu-demo" component={PvEDoudizhuDemoView} />
            </div>
        </>
    );
}

function App() {
    return (
        <Router>
            <AppRoutes />
        </Router>
    );
}

export default App;
